import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import SimpleA from 'components/display/SimpleAnchor'
import useFeatureFlag from 'hooks/useFeatureFlag'
import { promotionBanner } from 'featureFlags'

const Message = styled.p`
  ${typeStyle('-ds-font-body-regular')}
  text-align: center;
  margin: auto;

  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  a {
    color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    &:hover,
    &:link {
      color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
    }
  }
`

const Outer = styled.div`
  z-index: 1;
  box-sizing: border-box;
  width: 100%;
  padding: 16px;

  background-color: ${({ theme }) => theme?.['-ds-warning-200']?.value};
`

const marketOfferPaths = {
  NSW: '/au/nsw/collections/Black-Friday-Cyber-Monday-NSW',
  VIC: '/au/vic/collections/Black-Friday-Cyber-Monday-VIC',
  NZ: '/nz/collections/Black-Friday-Cyber-Monday-NZ',
} as const

type Props = {
  marketCode: GQL_MarketCode
}

const PromoBanner = ({ marketCode }: Props) => {
  const hasFeatureFlag = useFeatureFlag(promotionBanner)

  if (hasFeatureFlag !== true) {
    return null
  }

  if (marketCode !== 'NSW' && marketCode !== 'VIC' && marketCode !== 'NZ') {
    return null
  }

  const offersPath = marketOfferPaths[marketCode]

  return (
    <Outer>
      <Message>
        <strong>Black Friday to Cyber Monday sale on now!</strong> 25% off
        selected escapes.{' '}
        <SimpleA textDecoration="underline" href={offersPath}>
          View offers
        </SimpleA>
      </Message>
    </Outer>
  )
}

export default PromoBanner
